var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "RucpB_ahqt8VfTW7X2sDFa",
    x1: 9.703,
    x2: 16.585,
    y1: 26.119,
    y2: 37.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1784d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0864c5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#RucpB_ahqt8VfTW7X2sDFa)",
    d: "M20,25.026L5.011,25l0.001,11.002c0,0.999,0.737,1.844,1.726,1.981L20,39.818V25.026z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "RucpB_ahqt8VfTW7X2sDFb",
    x1: 24.604,
    x2: 44.545,
    y1: 27.13,
    y2: 40.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#31abec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1582d5"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#RucpB_ahqt8VfTW7X2sDFb)",
    d: "M22,25.03v15.065l18.722,2.59c1.202,0.166,2.274-0.767,2.274-1.981L43,25.066L22,25.03z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "RucpB_ahqt8VfTW7X2sDFc",
    x1: 8.142,
    x2: 25.788,
    y1: 11.699,
    y2: 27.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#31abec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1582d5"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#RucpB_ahqt8VfTW7X2sDFc)",
    d: "M20,8.256l-13.278,1.88c-0.987,0.14-1.721,0.985-1.72,1.982L5.014,23H20V8.256z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "RucpB_ahqt8VfTW7X2sDFd",
    x1: 25.913,
    x2: 56.031,
    y1: 10.147,
    y2: 30.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#54daff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25a2e5"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#RucpB_ahqt8VfTW7X2sDFd)",
    d: "M22,7.973V23h20.995V7.303c0-1.216-1.076-2.151-2.28-1.98L22,7.973z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows);
export default __webpack_public_path__ + "static/media/windows.a7408f3c1c07a2401cc8fda181193114.svg";
export { ForwardRef as ReactComponent };